export const ELEVATE_REALTIME_URI_SUFFIX = "/api/v3/realtime/";
export const FETCH_LICENSING_FOR_PLANT_URI_PREFIX = "/api/v3/licensing/plant";
export const FETCH_MEDIA_ASSESTS_URI_PREFIX = "/api/v3/media-manager/asset";
export const STORAGE_CURRENT_PLANT_KEY = "vi-current-plant";
export const STORAGE_JWT_ISS_KEY = "vi-jwt-iss";
export const STORAGE_JWT_ISSUER = "vimana.us";
